<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1"
       style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
       viewBox="0 0 4033 4033"
       xmlns:xlink="http://www.w3.org/1999/xlink">

   <g id="Vrstva_x0020_1">
    <path class="fil0"
          d="M2130 1161l0 -913c0,-137 -111,-248 -248,-248 -137,0 -248,111 -248,248l0 913 -594 0 0 -913c0,-137 -111,-248 -248,-248 -136,0 -247,111 -247,248l0 913 -545 0 0 2004c0,235 185,422 420,422l670 0 0 446 495 0 0 -446 706 0c235,0 433,-187 433,-422l0 -2004 -594 0z"/>
   </g>
  </svg>
</template>

<script>
export default {
  name: 'Device',
};
</script>

<style scoped>
.fil0 {
  fill: #56D6D1;
  fill-rule: nonzero
}
</style>
